import { authAPI } from '../../api'

const DEFAULT_STATE = {
  isLoggingIn: false,
  currentUser: null,
  serverErrorMsg: null
}

// Actions
export const types = {
  SET_CURRENT_USER: 'gulftree/auth/SET_CURRENT_USER',
  SET_SERVER_ERROR_MSG: 'gulftree/auth/SET_SERVER_ERROR_MSG'
}

// Reducer
export default function reducer(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {

    case types.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload
      }

    case types.SET_SERVER_ERROR_MSG:
      return {
        ...state,
        serverErrorMsg: action.payload
      }

    default:
      return state;
  }
}

// Action Creators
export function signIn(email, password) {
  return (dispatch) => {
    authAPI.signIn(email, password).then(res => {
      if (res.success) {
        dispatch({ type: types.SET_CURRENT_USER, payload: res.user })
        dispatch({ type: types.SET_SERVER_ERROR_MSG, payload: null })
      } else {
        dispatch({ type: types.SET_SERVER_ERROR_MSG, payload: res.message })
      }
    })
  }
}

export function signUp(email, password, passwordConfirm) {
  return (dispatch) => {
    authAPI.signUp(email, password, passwordConfirm).then(res => {
      if (res.success) {
        dispatch({ type: types.SET_CURRENT_USER, payload: res.user })
        dispatch({ type: types.SET_SERVER_ERROR_MSG, payload: null })
      } else {
        dispatch({ type: types.SET_SERVER_ERROR_MSG, payload: res.message })
      }
    })
  }
}

export function signOut() {
  return (dispatch) => {
    // Greedy signOut (not waiting for API response)
    authAPI.signOut()

    dispatch({
      type: types.SET_CURRENT_USER,
      payload: null,
    })
  }
}

export function getCurrentUser() {
  return dispatch => {
    authAPI.getCurrentUser().then(res => {
      dispatch({
        type: types.SET_CURRENT_USER,
        payload: res.user
      })
    })
  }
}
